module.exports = [
	[
		"AFG",
		"Afghanistan",
		"93"
	],
	[
		"ZAF",
		"Afrique du Sud",
		"27"
	],
	[
		"ALB",
		"Albanie",
		"355"
	],
	[
		"DZA",
		"Algérie",
		"213"
	],
	[
		"DEU",
		"Allemagne",
		"49"
	],
	[
		"AND",
		"Andorre",
		"376"
	],
	[
		"AGO",
		"Angola",
		"244"
	],
	[
		"AIA",
		"Anguilla",
		"1 264"
	],
	[
		"ATA",
		"Antarctique",
		"--+672"
	],
	[
		"SAU",
		"Arabie saoudite",
		"966"
	],
	[
		"ARG",
		"Argentine",
		"54"
	],
	[
		"ARM",
		"Arménie",
		"374"
	],
	[
		"ABW",
		"Aruba",
		"297"
	],
	[
		"AUS",
		"Australie",
		"61"
	],
	[
		"AUT",
		"Autriche",
		"43"
	],
	[
		"AZE",
		"Azerbaïdjan",
		"994"
	],
	[
		"BHS",
		"Bahamas",
		"1"
	],
	[
		"BHR",
		"Bahreïn",
		"973"
	],
	[
		"BGD",
		"Bangladesh",
		"880"
	],
	[
		"BRB",
		"Barbade",
		"1"
	],
	[
		"BEL",
		"Belgique",
		"32"
	],
	[
		"BLZ",
		"Belize",
		"501"
	],
	[
		"BEN",
		"Benin",
		"229"
	],
	[
		"BMU",
		"Bermudes",
		"1"
	],
	[
		"BTN",
		"Bhoutan",
		"975"
	],
	[
		"BLR",
		"Biélorussie",
		"375"
	],
	[
		"BOL",
		"Bolivie",
		"591"
	],
	[
		"BIH",
		"Bosnie-Herzégovine",
		"387"
	],
	[
		"BWA",
		"Botswana",
		"267"
	],
	[
		"BRA",
		"Brésil",
		"55"
	],
	[
		"BRN",
		"Brunei",
		"673"
	],
	[
		"BGR",
		"Bulgarie",
		"359"
	],
	[
		"BFA",
		"Burkina Faso",
		"226"
	],
	[
		"BDI",
		"Burundi",
		"257"
	],
	[
		"KHM",
		"Cambodge",
		"855"
	],
	[
		"CMR",
		"Cameroun",
		"237"
	],
	[
		"CAN",
		"Canada",
		"1"
	],
	[
		"CPV",
		"Cap-Vert",
		"238"
	],
	[
		"CAF",
		"Centrafricaine, république",
		"236"
	],
	[
		"CHL",
		"Chili",
		"56"
	],
	[
		"CHN",
		"Chine",
		"86"
	],
	[
		"CYP",
		"Chypre",
		"357"
	],
	[
		"COL",
		"Colombie",
		"57"
	],
	[
		"COM",
		"Comores",
		"269"
	],
	[
		"PRK",
		"Corée du Nord",
		"850"
	],
	[
		"KOR",
		"Corée du Sud",
		"82"
	],
	[
		"CRI",
		"Costa Rica",
		"506"
	],
	[
		"CIV",
		"Côte d'Ivoire",
		"225"
	],
	[
		"HRV",
		"Croatie",
		"385"
	],
	[
		"CUB",
		"Cuba",
		"53"
	],
	[
		"CUW",
		"Curaçao",
		"599"
	],
	[
		"DNK",
		"Danemark",
		"45"
	],
	[
		"DJI",
		"Djibouti",
		"253"
	],
	[
		"DMA",
		"Dominique",
		"1"
	],
	[
		"EGY",
		"Égypte",
		"20"
	],
	[
		"SLV",
		"El Salvador",
		"503"
	],
	[
		"ARE",
		"Émirats Arabes Unis",
		"971"
	],
	[
		"ECU",
		"Équateur",
		"593"
	],
	[
		"ERI",
		"Érythrée",
		"291"
	],
	[
		"ESP",
		"Espagne",
		"34"
	],
	[
		"EST",
		"Estonie",
		"372"
	],
	[
		"USA",
		"États-Unis",
		"1"
	],
	[
		"ETH",
		"Éthiopie",
		"251"
	],
	[
		"FJI",
		"Fidji",
		"679"
	],
	[
		"FIN",
		"Finlande",
		"358"
	],
	[
		"FRA",
		"France",
		"33"
	],
	[
		"GAB",
		"Gabon",
		"241"
	],
	[
		"GMB",
		"Gambie",
		"220"
	],
	[
		"GEO",
		"Géorgie",
		"995"
	],
	[
		"GHA",
		"Ghana",
		"233"
	],
	[
		"GIB",
		"Gibraltar",
		"350"
	],
	[
		"GBR",
		"Grande-Bretagne",
		"44"
	],
	[
		"GRC",
		"Grèce",
		"30"
	],
	[
		"GRL",
		"Groenland",
		"299"
	],
	[
		"GLP",
		"Guadeloupe",
		"590"
	],
	[
		"GUM",
		"Guam",
		"1 671"
	],
	[
		"GTM",
		"Guatemala",
		"502"
	],
	[
		"GIN",
		"Guinée",
		"224"
	],
	[
		"GNQ",
		"Guinée équatoriale",
		"240"
	],
	[
		"GNB",
		"Guinée-Bissau",
		"245"
	],
	[
		"GUY",
		"Guyana",
		"592"
	],
	[
		"HTI",
		"Haïti",
		"509"
	],
	[
		"HND",
		"Honduras",
		"504"
	],
	[
		"HKG",
		"Hong Kong",
		"852"
	],
	[
		"HUN",
		"Hongrie",
		"36"
	],
	[
		"IMN",
		"Île de Man",
		"44"
	],
	[
		"MUS",
		"Île Maurice",
		"230"
	],
	[
		"NFK",
		"Île Norfolk",
		"672"
	],
	[
		"CYM",
		"Îles Caïmanes",
		"1-345"
	],
	[
		"COK",
		"Îles Cook",
		"682"
	],
	[
		"FLK",
		"Îles Falkland",
		"500"
	],
	[
		"FRO",
		"Îles Féroé",
		"298"
	],
	[
		"MNP",
		"Îles Mariannes du Nord",
		"1 670"
	],
	[
		"MHL",
		"Îles Marshall",
		"692"
	],
	[
		"PCN",
		"Îles Pitcairn",
		"870"
	],
	[
		"SLB",
		"Îles Salomon",
		"677"
	],
	[
		"VGB",
		"Îles Vierges",
		"1 284"
	],
	[
		"IND",
		"Inde",
		"91"
	],
	[
		"IDN",
		"Indonésie",
		"62"
	],
	[
		"IRQ",
		"Irak",
		"964"
	],
	[
		"IRN",
		"Iran",
		"98"
	],
	[
		"IRL",
		"Irlande",
		"353"
	],
	[
		"ISL",
		"Islande",
		"354"
	],
	[
		"ISR",
		"Israël",
		"972"
	],
	[
		"ITA",
		"Italie",
		"39"
	],
	[
		"JAM",
		"Jamaïque",
		"1"
	],
	[
		"JPN",
		"Japon",
		"81"
	],
	[
		"JOR",
		"Jordanie",
		"962"
	],
	[
		"KAZ",
		"Kazakhstan",
		"7"
	],
	[
		"KEN",
		"Kenya",
		"254"
	],
	[
		"KGZ",
		"Kirghizistan",
		"996"
	],
	[
		"KIR",
		"Kiribati",
		"686"
	],
	[
		"XKX",
		"Kosovo",
		"381"
	],
	[
		"KWT",
		"Koweït",
		"965"
	],
	[
		"REU",
		"La Réunion",
		"262"
	],
	[
		"LAO",
		"Laos",
		"856"
	],
	[
		"LSO",
		"Lesotho",
		"266"
	],
	[
		"LVA",
		"Lettonie",
		"371"
	],
	[
		"LBN",
		"Liban",
		"961"
	],
	[
		"LBR",
		"Liberia",
		"231"
	],
	[
		"LBY",
		"Libye",
		"218"
	],
	[
		"LIE",
		"Liechtenstein",
		"423"
	],
	[
		"LTU",
		"Lituanie",
		"370"
	],
	[
		"LUX",
		"Luxembourg",
		"352"
	],
	[
		"MAC",
		"Macao",
		"853"
	],
	[
		"MKD",
		"Macédoine",
		"389"
	],
	[
		"MDG",
		"Madagascar",
		"261"
	],
	[
		"MYS",
		"Malaisie",
		"60"
	],
	[
		"MWI",
		"Malawi",
		"265"
	],
	[
		"MDV",
		"Maldives",
		"960"
	],
	[
		"MLI",
		"Mali",
		"223"
	],
	[
		"MLT",
		"Malte",
		"356"
	],
	[
		"MAR",
		"Maroc",
		"212"
	],
	[
		"MRT",
		"Mauritanie",
		"222"
	],
	[
		"MEX",
		"Mexique",
		"52"
	],
	[
		"FSM",
		"Micronésie",
		"691"
	],
	[
		"MDA",
		"Moldavie",
		"373"
	],
	[
		"MCO",
		"Monaco",
		"377"
	],
	[
		"MNG",
		"Mongolie",
		"976"
	],
	[
		"MNE",
		"Monténégro",
		"382"
	],
	[
		"MSR",
		"Montserrat",
		"1 664"
	],
	[
		"MOZ",
		"Mozambique",
		"258"
	],
	[
		"MMR",
		"Myanmar",
		"95"
	],
	[
		"NAM",
		"Namibie",
		"264"
	],
	[
		"NRU",
		"Nauru",
		"674"
	],
	[
		"NPL",
		"Népal",
		"977"
	],
	[
		"NIC",
		"Nicaragua",
		"505"
	],
	[
		"NER",
		"Niger",
		"227"
	],
	[
		"NGA",
		"Nigéria",
		"234"
	],
	[
		"NIU",
		"Nioué",
		"683"
	],
	[
		"NOR",
		"Norvège",
		"47"
	],
	[
		"NCL",
		"Nouvelle-Calédonie",
		"687"
	],
	[
		"NZL",
		"Nouvelle-Zélande",
		"64"
	],
	[
		"OMN",
		"Oman",
		"968"
	],
	[
		"UGA",
		"Ouganda",
		"256"
	],
	[
		"UZB",
		"Ouzbékistan",
		"998"
	],
	[
		"PAK",
		"Pakistan",
		"92"
	],
	[
		"PLW",
		"Palaos",
		"680"
	],
	[
		"PAN",
		"Panama",
		"507"
	],
	[
		"PNG",
		"Papouasie-Nouvelle-Guinée",
		"675"
	],
	[
		"PRY",
		"Paraguay",
		"595"
	],
	[
		"NLD",
		"Pays-Bas",
		"31"
	],
	[
		"PER",
		"Pérou",
		"51"
	],
	[
		"PHL",
		"Philippines",
		"63"
	],
	[
		"POL",
		"Pologne",
		"48"
	],
	[
		"PYF",
		"Polynésie Française",
		"689"
	],
	[
		"PRI",
		"Porto Rico",
		"1"
	],
	[
		"PRT",
		"Portugal",
		"351"
	],
	[
		"QAT",
		"Qatar",
		"974"
	],
	[
		"COD",
		"République démocratique du Congo",
		"243"
	],
	[
		"DOM",
		"République Dominicaine",
		"1"
	],
	[
		"COG",
		"République du Congo",
		"242"
	],
	[
		"CZE",
		"République tchèque",
		"420"
	],
	[
		"ROU",
		"Roumanie",
		"40"
	],
	[
		"RUS",
		"Russie",
		"7"
	],
	[
		"RWA",
		"Rwanda",
		"250"
	],
	[
		"ESH",
		"Sahara Occidental",
		"212"
	],
	[
		"BLM",
		"Saint-Barthélemy",
		"590"
	],
	[
		"KNA",
		"Saint-Christophe-et-Niévès",
		"1"
	],
	[
		"SMR",
		"Saint-Marin",
		"378"
	],
	[
		"MAF",
		"Saint-Martin",
		"1 599"
	],
	[
		"SPM",
		"Saint-Pierre et Miquelon",
		"508"
	],
	[
		"VCT",
		"Saint-Vincent-et-les-Grenadines",
		"1"
	],
	[
		"SHN",
		"Sainte-Hélène",
		"290"
	],
	[
		"LCA",
		"Sainte-Lucie",
		"1"
	],
	[
		"WSM",
		"Samoa",
		"685"
	],
	[
		"ASM",
		"Samoa américaines",
		"1 684"
	],
	[
		"STP",
		"Sao-Tomé-et-Principe",
		"239"
	],
	[
		"SEN",
		"Sénégal",
		"221"
	],
	[
		"SRB",
		"Serbie",
		"381"
	],
	[
		"SYC",
		"Seychelles",
		"248"
	],
	[
		"SLE",
		"Sierra Leone",
		"232"
	],
	[
		"SGP",
		"Singapour",
		"65"
	],
	[
		"SVK",
		"Slovaquie",
		"421"
	],
	[
		"SVN",
		"Slovénie",
		"386"
	],
	[
		"SOM",
		"Somalie",
		"252"
	],
	[
		"SDN",
		"Soudan",
		"249"
	],
	[
		"SSD",
		"Soudan du Sud",
		"211"
	],
	[
		"LKA",
		"Sri Lanka",
		"94"
	],
	[
		"SWE",
		"Suède",
		"46"
	],
	[
		"CHE",
		"Suisse",
		"41"
	],
	[
		"SUR",
		"Suriname",
		"597"
	],
	[
		"SWZ",
		"Swaziland",
		"268"
	],
	[
		"SYR",
		"Syrie",
		"963"
	],
	[
		"TJK",
		"Tadjikistan",
		"992"
	],
	[
		"TWN",
		"Taiwan",
		"886"
	],
	[
		"TZA",
		"Tanzanie",
		"255"
	],
	[
		"THA",
		"Thaïlande",
		"66"
	],
	[
		"TLS",
		"Timor Oriental",
		"670"
	],
	[
		"TGO",
		"Togo",
		"228"
	],
	[
		"TKL",
		"Tokelau",
		"--+690"
	],
	[
		"TTO",
		"Trinité-et-Tobago",
		"1"
	],
	[
		"TUN",
		"Tunisie",
		"216"
	],
	[
		"TKM",
		"Turkmenistan",
		"993"
	],
	[
		"TUR",
		"Turquie",
		"90"
	],
	[
		"TUV",
		"Tuvalu",
		"688"
	],
	[
		"UKR",
		"Ukraine",
		"380"
	],
	[
		"URY",
		"Uruguay",
		"598"
	],
	[
		"VUT",
		"Vanuatu",
		"678"
	],
	[
		"VAT",
		"Vatican",
		"39"
	],
	[
		"VEN",
		"Venezuela",
		"58"
	],
	[
		"VNM",
		"Viêt Nam",
		"84"
	],
	[
		"YEM",
		"Yémen",
		"967"
	],
	[
		"ZMB",
		"Zambie",
		"260"
	],
	[
		"ZWE",
		"Zimbabwe",
		"263"
	]
];


/*****************
 ** WEBPACK FOOTER
 ** ./shared/phone.json
 ** module id = 786
 ** module chunks = 0 1
 **/